import { BadgeOvalStyled } from "./styled/BadgeOvalStyled";
import BinIcon from "../icon/IconWrapped";
import classNames from "classnames";

/**
 * @source https://www.figma.com/file/O3ikmxQ658tKqvq3irCUqv/Jetvix-UI-kit?type=design&node-id=1385-10854&mode=dev
 */

interface IBadgeOvalProps {
    children: any,
    size?: 'sm' | 'md' | 'lg',
    variant?: 'bonus' | 'cashback',
}

function BadgeOval(props: IBadgeOvalProps) {
    const {
        children,
        size = 'md',
        variant = 'bonus',
    } = props;

    return <BadgeOvalStyled className={classNames(size, variant)}>
        {children}
        {
            variant === 'bonus' && <BinIcon name={'IcGift'}/>
        }
        {
            variant === 'cashback' && <BinIcon name={'IcCashback'}/>
        }
    </BadgeOvalStyled>
}

export default BadgeOval;
